exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-dashboard-550-e-8400-e-29-b-41-d-4-a-716-446655440000-js": () => import("./../../../src/pages/dashboard-550e8400-e29b-41d4-a716-446655440000.js" /* webpackChunkName: "component---src-pages-dashboard-550-e-8400-e-29-b-41-d-4-a-716-446655440000-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

